<template>
  <model-table
    :collection="tipShares"
    :show-add="false"
    :show-edit="false"
    :columns="[
      { field: 'id' },
      { name: 'order', field: tipShare => tipShare.orderItem.order, component: 'model' },
      { field: 'tipShareRule', component: 'model' },
      { name: 'paymentType', field: tipShare => $_.startCase(tipShare.paymentType), component: 'chip' },
      { name: 'tipIncomeAmount', field: tipShare => tipShare.tipIncomeAmount, component: 'money' },
      { name: 'tipOutAmount', field: tipShare => tipShare.tipOutAmount, component: 'money' },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
  >
    <tip-share-form />
  </model-table>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import TipShareForm from 'src/modules/admin/tip/TipShareForm'

export default {
  name: 'TipShareTable',
  components: {
    ModelTable,
    TipShareForm
  },
  models: {
    tipShares: {
      tipShareRule: {
        fields: ['id', 'name']
      },
      orderItem: {
        fields: ['id', 'amount', 'price', 'taxAmount', 'state'],
        paidUser: {
          fields: ['id', 'firstName', 'lastName']
        },
        order: {
          fields: ['id']
        }
      },
      tipPoolTips: {
        fields: ['id', 'amount'],
        tipPool: {
          fields: ['id'],
          tipPoolType: {
            fields: ['id', 'name']
          }
        }
      },
      variables () {
        return {
          noCount: true
        }
      }
    }
  }
}
</script>
